<div *ngIf="loadingOffers$ | async; else offers" class="loading-container">
  <mat-spinner diameter="24" class="loading-offers"></mat-spinner>
  <div class="loading-text">Loading Offers...</div>
</div>
<ng-template #offers>
  <!-- ACTIVE DEALS VIEW -->
  <div *ngIf="dealStage !== 'inactive' && dealStage !== 'funded'; else offerHistory">
    <div class="offers-header-container">
      <div class="offers-header-section offers-header-section-left">
        <h3 class="mb-0">Offers</h3>
      </div>
      <div class="offers-header-section offers-header-section-right">
        <app-create-offer-button *ngIf="canCreate()" [loanProductType]="loanProductType" (createOffer)="createOffer($event)"
          [offerNumber]="(dealOffers$ | async) ? (dealOffers$ | async).length + 1 : 1">
        </app-create-offer-button>
      </div>
    </div>
    <app-alert *ngIf="updateOfferError$ | async" level="error" message="{{ updateOfferError$ | async }}"
    dismissDelay="2000"
    (dismissed)="dismissAlert()"
    ></app-alert>
    <app-offer *ngFor="let offer of dealOffers$ | async; index as i;"
      [offer]="offer"
      [acceptedOfferId]="acceptedOfferId$ | async"
      [offerNumber]="((dealOffers$ | async).length - i)"
      [updateError]="error$ | async"
      [dealStage]="dealStage"
      [canEdit]="canEdit()"
      [canDelete]="canDelete()"
      [readOnly]="readOnly"
      [hasContractRequest]="hasContractRequest"
      (publish)="publishOffer($event)"
      (removeFromPortal)="removeFromPortal($event)"
      (expandToggle)="expandToggle($event)"
      (acceptedToggle)="acceptedToggle($event)"
      (editOffer)="editOffer($event)"
      (createOffer)="createOffer($event)"
      (deleteOffer)="deleteOffer($event)"
    >
    </app-offer>
    <offer-option *ngFor="let option of offerOptions$ | async; index as i;"
      [option]="option"
      [cardExpandable]="true"
    >
    </offer-option>
    <div
      *ngIf="(!(dealOffers$ | async).length)">
      <span class="mb-0">No offers on this deal</span>
    </div>
  </div>

  <!-- HISTORY VIEW (INACTIVE/FUNDED) -->
  <ng-template #offerHistory>
    <!-- FUNDED OFFER -->
    <div *ngIf="dealStage === 'funded'">
      <div class="offers-header-container">
        <div class="offers-header-section offers-header-section-left">
          <h3 class="mb-0">Accepted Offer</h3>
        </div>
      </div>
      <app-offer *ngFor="let offer of fundedOffer$ | async; index as i;"
        [offer]="offer"
        [acceptedOfferId]="acceptedOfferId$ | async"
        [offerNumber]="1"
        [dealStage]="dealStage"
        [canEdit]=" canEdit()"
        [canEditInactiveOffers]="canEditInactiveOffers()"
        [canDelete]="canDelete()"
        (publish)="publishOffer($event)"
        (removeFromPortal)="removeFromPortal($event)"
        (expandToggle)="expandToggle($event)"
        (acceptedToggle)="acceptedToggle($event)"
        (editOffer)="editOffer($event)">
      </app-offer>
    </div>
    <!-- DECLINED OFFERS -->
    <div *ngIf="(dealOffers$ | async) && (dealOffers$ | async).length > 0">
      <div class="offers-header-container">
        <div class="offers-header-section offers-header-section-left">
          <h3 class="mb-0 mt-4">Declined Offers</h3>
        </div>
      </div>
      <app-offer *ngFor="let offer of dealOffers$ | async; index as i;"
        [offer]="offer"
        [acceptedOfferId]="acceptedOfferId$ | async"
        [offerNumber]="((dealOffers$ | async).length - i)"
        [dealStage]="dealStage"
        [canEdit]="canEdit()"
        [canEditInactiveOffers]="canEditInactiveOffers()"
        [canDelete]="canDelete()"
        (publish)="publishOffer($event)"
        (removeFromPortal)="removeFromPortal($event)"
        (expandToggle)="expandToggle($event)"
        (acceptedToggle)="acceptedToggle($event)"
        (editOffer)="editOffer($event)">
      </app-offer>
    </div>
    <!-- NO OFFERS -->
    <div
      *ngIf="(!(dealOffers$ | async).length) && ((fundedOffer$ | async) && (fundedOffer$ | async).length === 0)">
      <h3 class="mb-0">No offers were made on this deal...</h3>
    </div>
  </ng-template>
</ng-template>
